export const USER_ACTIVITY_EVENTS = ["mousedown", "keydown", "touchstart", "pointerdown"];

/**
 * Tracks idle time with periodic checks instead of a single long setTimeout so
 * background-tab throttling and programmatic scroll events cannot block logout.
 */
export function createSessionInactivityTimer({
  inactivityMs,
  onTimeout,
  checkIntervalMs,
  now = () => Date.now(),
}) {
  let lastActivityAt = now();
  let intervalId = null;
  let stopped = false;
  let timeoutTriggered = false;

  const touchActivity = () => {
    if (stopped) return;
    lastActivityAt = now();
  };

  const evaluate = () => {
    if (stopped || timeoutTriggered) return;
    if (now() - lastActivityAt >= inactivityMs) {
      timeoutTriggered = true;
      onTimeout();
    }
  };

  const onVisibilityChange = () => {
    if (typeof document === "undefined") return;
    if (document.visibilityState === "visible") {
      evaluate();
    }
  };

  const start = () => {
    USER_ACTIVITY_EVENTS.forEach((eventName) => {
      window.addEventListener(eventName, touchActivity, { passive: true });
    });
    document.addEventListener("visibilitychange", onVisibilityChange);
    intervalId = window.setInterval(evaluate, checkIntervalMs);
    touchActivity();

    return () => {
      stopped = true;
      if (intervalId != null) {
        window.clearInterval(intervalId);
        intervalId = null;
      }
      USER_ACTIVITY_EVENTS.forEach((eventName) => {
        window.removeEventListener(eventName, touchActivity);
      });
      document.removeEventListener("visibilitychange", onVisibilityChange);
    };
  };

  return { start, touchActivity, evaluate };
}
